import { render, staticRenderFns } from "./scroll-to-jumper.vue?vue&type=template&id=138db0e3&scoped=true&"
import script from "./scroll-to-jumper.vue?vue&type=script&lang=js&"
export * from "./scroll-to-jumper.vue?vue&type=script&lang=js&"
import style0 from "./scroll-to-jumper.vue?vue&type=style&index=0&id=138db0e3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138db0e3",
  null
  
)

export default component.exports